import { Link, useNavigate } from 'react-router-dom';
import { FiArrowUp, FiGithub, FiLinkedin, FiMail } from 'react-icons/fi';
import { PALETTE_OPEN_EVENT } from '../CommandPalette/CommandPalette';
import { scrollToSection } from '../../scroll/scroll';
import './footer.css';

const IS_MAC = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);
const socials = [
  [FiGithub, 'GitHub', 'https://github.com/DiarmuidHe'],
  [FiLinkedin, 'LinkedIn', 'https://www.linkedin.com/in/d-hession'],
  [FiMail, 'Email', 'mailto:code@diarmuid.dev'],
];

export default function Footer() {
  const navigate = useNavigate();
  const jump = (event, id) => {
    event.preventDefault();
    if (window.location.hash === `#${id}`) scrollToSection(id);
    else navigate(`/#${id}`);
  };
  return <footer className="footer text-light">
    <div className="container footer-inner">
      <div className="footer-brand"><h2 className="footer-name">Diarmuid Hession</h2><p className="footer-role">Full Stack Developer</p></div>
      <nav aria-label="Footer"><ul className="footer-links">
        {['projects', 'experience', 'skills', 'education', 'about', 'contact'].map((id) => <li key={id}><a href={`#${id}`} onClick={(e) => jump(e, id)}>{id[0].toUpperCase() + id.slice(1)}</a></li>)}
        <li><Link to="/cv">CV</Link></li><li><Link to="/weather">Weather</Link></li><li><Link to="/chat">Chat</Link></li>
      </ul></nav>
      <div className="footer-socials">{socials.map(([Icon, label, href]) => <a key={label} href={href} aria-label={label} {...(href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}><Icon size={19} /></a>)}</div>
    </div>
    <div className="footer-bottom"><div className="container d-flex flex-wrap justify-content-between align-items-center gap-2">
      <p className="mb-0">© {new Date().getFullYear()} Diarmuid Hession.</p>
      <div className="d-flex align-items-center gap-4"><button type="button" className="footer-jump" onClick={() => window.dispatchEvent(new Event(PALETTE_OPEN_EVENT))}>Quick jump <kbd className="footer-kbd">{IS_MAC ? '⌘' : 'Ctrl'} K</kbd></button><a href="#Home" onClick={(e) => jump(e, 'Home')} className="back-to-top">Back to top <FiArrowUp aria-hidden="true" /></a></div>
    </div></div>
  </footer>;
}
